<template>
    <div class="dashboard-heading">
        <div class="row">
            <div class="col-md-6">
                <h4 class="dashboard-title">{{dashboards.active.name}} Dashboard</h4>
            </div>
            <div class="col-md-6">
                <div class="dropdown pull-right product-tool-menu"  style="margin-left:5px;">
                    <button type="button" @click="$parent.toggleNotifications()" class="btn btn-outline-primary btn-notification-toggle" :class="{'is-open': isNotificationsVisible}">
                        <i class="fa fa-bell" aria-hidden="true"></i>
                        <span class="notification-count" v-if="notification.length > 0">{{notification.length}}</span>
                    </button>
                </div>
                <div v-if="$parent.uiStates.allowEdit" class="dropdown pull-right product-tool-menu"  style="margin-left:5px;">
                    <button type="button" class="btn btn-outline-primary " data-toggle="dropdown">
                        <i class="fa fa-cog" aria-hidden="true"></i>
                    </button>
                    <div class="dropdown-menu dropdown-menu-right" id="batch_operation">
                        <a class="dropdown-item" href="#" @click="enterAddMode()">Add New Dashboard</a>
                        <!-- <a  class="dropdown-item" href="#" @click.prevent="$parent.uiStates.editDisabled = false" >Edit Dashboard</a> -->
                        <!-- <a  class="dropdown-item" href="#">Share Dashboard</a> -->
                    </div>
                </div>
                <div class="btn-group navbar-createproduct pull-right" v-if="dashboards.usersDashboards.length > 0 && !$parent.dashboardCreateMode">
                  <button class="btn btn-outline-primary btn-current-dashboard" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">{{dashboards.active.name}}</button>
                    <button type="button" class="btn btn-outline-primary dropdown-toggle dropdown-toggle-split" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <span class="sr-only">Toggle Dropdown</span>
                    </button>
                    <div class="dropdown-menu dropdown-menu-right">
                        <a v-for="dashboard in dashboards.usersDashboards" @click.prevent="setActiveDashboard(dashboard.id)" class="dropdown-item" style="position: relative;"" href="#">
                            {{dashboard.name}}
                            <span v-if="dashboard.default != 1" class="delete-dashboard" @click.prevent="$parent.deleteDashboard(dashboard.id)"><i class="fa fa-times"></i></span>
                        </a>
                    </div>
                </div>
                <div v-else  class=" pull-right create-controls" :class="{'open': $parent.dashboardCreateMode}">
                    <a href="#" @click.prevent="$parent.createCancel()" class="btn pull-right btn-outline-primary btn-cancel-create"">Cancel</a>
                    <div class="btn-group pull-right" style="position: relative !important;">
                        <input v-model="$parent.dashboards.active.name" type="text" name="new-name" class="form-control">
                        <button class="btn btn-primary" :disabled="$parent.dashboards.active.name == '' ||  $parent.dashboards.active.widgets.length == 0" @click="$parent.createDashboard()">Save</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script type="text/javascript">
    var base_url = window.location.protocol + "//" + window.location.host



    import Vue from 'vue';
    import VueEvents from 'vue-events'
    import axios from 'axios'
    import moment from 'moment';


    Vue.use(VueEvents)

    export default {
        name: 'dashboard-heading',
        props: ['isNotificationsVisible', 'notification', 'dashboards'],
        methods: {
            setActiveDashboard: function(dashboardID){
                this.$parent.uiStates.showLoading = true;
                this.$parent.loadDashboardListingById(dashboardID);
            },
            enterAddMode: function(){
                this.$parent.dashboardCreateMode = !this.$parent.dashboardCreateMode
                this.$parent.dashboards.active = this.$parent.tempDashboard;
                this.$parent.uiStates.editDisabled = false;

            },
        },

    };
</script>

<style scoped="" lang="scss">
    .create-controls{
        transition: max-width 0.3s linear;
        max-width: 1px;
        overflow:hidden;
        &.open{
            transition: max-width 0.3s linear;
            max-width: 330px;
        }
    }
    .dashboard-title{
        margin-top: 11px !important;
        margin-bottom: 0;
        font-size: 18px;
        color: #1F2529;
        text-align: left;
    }
    .dashboard-heading{
        margin-bottom:30px;
    }
    .btn-notification-toggle{
        position: relative;
        .notification-count{
            position: absolute;
            top: 4px;
            right: 4px;
            width:16px;
            height:16px;
            color:#fff;
            background-color: #AB5755;
            border-radius: 50%;
            font-size:11px;
            font-weight: 800;
        }
        .fa{
            transition: transform 0.3s linear;
        }
        &.is-open{
            .fa{
                transition: transform 0.3s linear;
                transform: rotate(45deg);
            }
        }
    }
    .product-tool-menu .dropdown-menu .dropdown-item{
        padding: 10px 15px !important;
    }
    .product-tool-menu{
        .fa{
            transition: transform 0.3s linear;
        }
    }
    .product-tool-menu.show{
        .fa{
            transition: transform 0.3s linear;
            transform: rotate(61deg);
        }
    }
    .delete-dashboard{
        position: absolute;
        top: 0px;
        right: 0px;
        padding: 8px 10px;
        bottom: 0;
        color:#AB5755;
        cursor:pointer;
        font-size: 16px;

    }
    .btn-cancel-create{
        margin-left:5px;
        border: solid 1px #dedede;
    }
</style>
